import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { PeticionApiInterceptor } from './interceptor/peticion-api.interceptor';
import { sessionInterceptor } from './interceptor/session.interceptor';
import { DatePipe, DecimalPipe } from '@angular/common';
import { RECAPTCHA_V19_SITE_KEY } from 'recaptcha-v19';
import { peticionApiReportsInterceptor } from './interceptor/peticion-api-reports.interceptor';
import { peticionHistoryInterceptor } from 'interceptor/peticion-history.interceptor';
import { TsiErrorHandler } from 'errors/tsiErrorHandler';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
    DatePipe, DecimalPipe,
  provideRouter(routes, withComponentInputBinding()),
  provideHttpClient(withInterceptors([peticionHistoryInterceptor, sessionInterceptor, PeticionApiInterceptor, peticionApiReportsInterceptor])),
  provideAnimationsAsync(),
  { provide: RECAPTCHA_V19_SITE_KEY, useValue: environment.recaptcha.siteKey },
  { provide: ErrorHandler, useClass: TsiErrorHandler }
  ]
}
